var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isSpendAndGetReward
        ? [
            _c(
              "div",
              {
                staticClass:
                  "reward-quantity-display d-inline-flex align-items-center px-2 py-1 rounded",
                attrs: { id: _vm.id + "_reward_" + _vm.product.id },
              },
              [
                _c("span", { staticClass: "font-weight-bold" }, [
                  _vm._v(_vm._s(_vm.getItemQuantity) + "x"),
                ]),
              ]
            ),
          ]
        : _vm.mode === "edit"
        ? [
            _c("FormulateInput", {
              attrs: {
                id: _vm.id + "_pId_" + _vm.product.id,
                type: "osk-number-with-buttons",
                name: _vm.id + "_pId_" + _vm.product.id,
                "right-disabled": _vm.addButtonDisabled,
              },
              on: {
                "focus-intercept": _vm.onFocusIntercept,
                onInput: _vm.onOskInput,
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                leftClick: _vm.onMinusClick,
                rightClick: _vm.onPlusClick,
              },
              model: {
                value: _vm.getItemQuantity,
                callback: function ($$v) {
                  _vm.getItemQuantity = $$v
                },
                expression: "getItemQuantity",
              },
            }),
          ]
        : _vm.mode === "add"
        ? [
            _c("e-button", {
              staticClass: "atm-btn",
              attrs: {
                id: _vm.id + "_add_btn",
                variant: "primary",
                size: "sm",
                icon: "plus",
                busy: _vm.busy,
              },
              on: { click: _vm.onAddSuggestionClick },
            }),
          ]
        : _vm.mode === "add-suggestion"
        ? [
            _c("e-button", {
              staticClass: "atm-btn",
              attrs: {
                id: _vm.id + "_add_btn",
                variant: "outline-primary",
                size: "sm",
                text: _vm.$t("Adicionar"),
                busy: _vm.busy,
              },
              on: { click: _vm.onAddSuggestionClick },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }